import { useMediaQuery, Typography, IconButton } from '@mui/material';
import { ContainedButton } from '../../../../../commons/hoc';
import styles from './BannerCarousal.module.scss';
import Router from 'next/router';
import Image from 'next/image';
import ArrowIcon from './ArrowIcon';

export default function Overlay({ leftBtn, rightBtn, data }) {
  const handleRightBtn = () => {
    if (rightBtn) rightBtn();
  };

  const handleLeftBtn = () => {
    if (leftBtn) leftBtn();
  };

  return (
    <div className={styles.overlayContainer}>
      <div className={styles.innerContainer}>
        <div className={styles.content}>
          <Typography variant="h5" color="white">
            Stories From People Like You
          </Typography>
          <Typography variant="h3" color="white" className={styles.title1}>
            "{data.review}"
          </Typography>
          <div style={{ marginTop: 'auto' }}>
            <Typography variant="h4" color="white" className={styles.reviewer}>
              {data.name}
            </Typography>
            <div className={styles.productCard}>
              <div className={styles.productCardContainer}>
                <div className={styles.productCardImg}>
                  <Image
                    src={data.productImg}
                    layout="fill"
                    objectFit="contain"
                  />
                </div>
                <div className={styles.productCardContent}>
                  <Typography variant="p1">{data.category}</Typography>
                  <Typography variant="h4" color="primary.main">
                    {data.productName}
                  </Typography>
                </div>
                <div className={styles.cardBtn}>
                  <ContainedButton
                    onClick={() => {
                      Router.push('#buy', undefined, {
                        shallow: true,
                        scroll: false,
                      });
                    }}
                    underline="none"
                    color="primary.white"
                  >
                    Buy Now
                  </ContainedButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.slideNav}>
          <IconButton className={styles.iconBtn} onClick={handleLeftBtn}>
            <ArrowIcon isRotated={true} color={'#004152'} />
          </IconButton>
          <IconButton className={styles.iconBtn} onClick={handleRightBtn}>
            <ArrowIcon color={'#004152'} />
          </IconButton>
        </div>
      </div>
    </div>
  );
}
